import { indexItems } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

const iconBgMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-600',
  secondary: 'bg-secondary-100 text-secondary-600',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门专题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              探索海角网最受欢迎的内容分类，找到你感兴趣的专题领域
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {indexItems.map((item) => (
              <a
                key={item.id}
                href="#media"
                className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-50/80 border border-background-200/60 transition-all cursor-pointer"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${iconBgMap[item.color]}`}>
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                </div>
                <span className={`text-xs font-medium px-2 py-1 rounded-full flex-shrink-0 ${colorMap[item.color]}`}>
                  {item.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}